import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  sendOtp,
  verifyOtp,
  sendEmailVerify,
  verifySmsOtp,
} from '../../firebase/auth';
import styles from './Verify.module.css';
import Footer from '../../Components/Footer/Footer';
import { getAuth } from 'firebase/auth';
import { doc, getDoc, collection, getFirestore } from 'firebase/firestore';
import { CircularProgress } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

function Verify() {
  let navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const [userVerifyCode, setUserVerifyCode] = useState('');
  const [error, setError] = useState('');
  const [method, setMethod] = useState(''); // 'phone' or 'email'
  const [hasPhone, setHasPhone] = useState(false);
  const [isMethodSelected, setIsMethodSelected] = useState(false);
  const [verificationId, setVerificationId] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userPhone, setUserPhone] = useState('');
  const { setUserVerified } = useAuth();

  useEffect(() => {
    const checkUserPhoneNumber = async () => {
      setIsLoading(true);
      try {
        const auth = getAuth();
        const user = auth.currentUser;

        if (!user) {
          throw new Error('No user signed in.');
        }

        // Fetch user data from Firestore
        const db = getFirestore();
        const userDocRef = doc(collection(db, 'users'), user.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();

          setUserEmail(userData.email);
          setUserPhone(userData.phone);

          // const userPhone = userData.phone;
          setMethod('email');
          setIsMethodSelected(true);
          await sendEmailVerify(user, userData.email);
          setError('Verification email sent. Please check your inbox.');
          // if (userPhone) {
          //   setHasPhone(true);
          // } else {
          //   setMethod('email');
          //   setIsMethodSelected(true);
          //   await sendEmailVerify(user, userData.email);
          //   setError('Verification email sent. Please check your inbox.');
          // }
        }
      } catch (error) {
        console.error('Error checking user phone number:', error);
        setError('Error initializing verification method. Please try again.');
      } finally {
        setIsLoading(false); // Ensure loading state is reset after processing
      }
    };

    checkUserPhoneNumber();
  }, []);

  // const handleConfirm = async () => {
  //   try {
  //     const auth = getAuth();
  //     const user = auth.currentUser;

  //     if (!user) {
  //       throw new Error('No user signed in.');
  //     }
  //     setIsMethodSelected(true);

  //     if (method === 'phone') {
  //       // Send OTP to phone
  //       const verificationId = await sendOtp(user, userPhone);
  //       setVerificationId(verificationId);
  //     } else {
  //       // Send email verification
  //       await sendEmailVerify(user, userEmail);
  //       setError('Verification email sent. Please check your inbox.');
  //     }
  //   } catch (error) {
  //     console.error('Error sending verification:', error);
  //     setError('Error sending verification. Please try again.');
  //   }
  // };

  const handleVerify = async (e) => {
    e.preventDefault();
    try {
      const auth = getAuth();
      const user = auth.currentUser;

      if (!user) {
        throw new Error('No user signed in.');
      }

      const isVerified = await verifyOtp(user.uid, userVerifyCode);

      if (isVerified) {
        setUserVerified(true);
        localStorage.setItem('userVerified', true);

        // Navigate to the next page after verification
        navigate('/submit');
      } else {
        setError('Incorrect code. Please try again.');
      }
    } catch (error) {
      console.error('Error verifying:', error);
      setError('Verification failed. Please try again.');
    }
  };

  return (
    <>
      <div className={styles.loginContainer}>
        <div id="recaptcha-container-id"></div>
        <div className={styles.staffLoginContainer}>
          {isLoading && (
            <div className={styles.loading}>
              <CircularProgress />
            </div>
          )}
          <h3>Verify</h3>
          {error && <p className={styles.error}>{error}</p>}
          {/* {hasPhone && !isMethodSelected && (
            <div className={styles.methodSelection}>
              <label>
                <input
                  type="radio"
                  value="phone"
                  checked={method === 'phone'}
                  onChange={() => setMethod('phone')}
                />
                Phone
              </label>
              <label>
                <input
                  type="radio"
                  value="email"
                  checked={method === 'email'}
                  onChange={() => setMethod('email')}
                />
                Email
              </label>
              <button onClick={handleConfirm}>Confirm</button>
            </div>
          )} */}
          {(isMethodSelected || !hasPhone) && (
            <form onSubmit={handleVerify}>
              <input
                type="text"
                name="userVerifyCode"
                placeholder="Code"
                value={userVerifyCode}
                onChange={(e) => setUserVerifyCode(e.target.value)}
                required
                autoFocus
                autoComplete="false"
              />
              <button type="submit">Submit</button>
            </form>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Verify;
